import { PropsWithChildren } from 'react';
import styles from './Table.module.css';

export function Bar({ children }: PropsWithChildren) {
  return <div className={styles.bar}>{children}</div>;
}
